import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { VERSION } from '../../../environments/version';
import { ProfileFeature } from 'src/app/store/states/auth.state';
import { MENU_CONFIG, MenuItem } from 'src/app/configs/menu.config';

@Component({
  selector: 'cube-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss'],
})
export class SidemenuComponent implements OnChanges {
  @Input() iconOnly: boolean | null | undefined = false;
  @Input() features: Array<ProfileFeature> | undefined;
  @Output() clicked: EventEmitter<string> = new EventEmitter<string>();
  menu: Array<MenuItem> | undefined;
  version = VERSION;

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['features']?.currentValue) {
      const featureRoles = this.features?.map((feature: ProfileFeature): string => feature.name);
      this.menu = MENU_CONFIG.filter((menuItem: MenuItem) => featureRoles?.some((role) => menuItem.roles.includes(role)));
    }
  }
}
